class TextField extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //if you want a field disabled, you NEED an id for it
        if (this.props.disabled) {
            $("#" + this.props.id).prop("disabled", true);
        }
    }

    inputChange(event) {

        var inputText;

        if (event.target.type == "checkbox") {
            if (this.props.YesNo) {
                if (event.target.checked)
                    inputText = "1";
                else
                    inputText = "0";
            }
            else {
                inputText = event.target.checked
            }
        }
        else {
            inputText = event.target.value
        }

        if (this.props.NumbersOnly) {

            if (inputText != "" && inputText.charAt(inputText.length - 1) != "." && inputText.charAt(inputText.length - 1) != "0" && inputText.charAt(inputText.length - 1) != ",") {
                inputText = inputText.split(',').join('')
                var value = parseFloat(inputText);
                if (!isNaN(value))
                    inputText = value;
                else
                    inputText = this.props.value;
            }
        }

        if (this.props.characterLimit != null) {
            if (!(inputText.length > this.props.characterLimit)) {
                this.props.onFieldChanged(inputText);
            }
        }
        else {
            this.props.onFieldChanged(inputText);
        }
    }

    OnBlur(event) {
        if (this.props.onBlur != null)
            this.props.onBlur(event);
    }

    OnFocus(event) {
        if (this.props.onFocus != null)
            this.props.onFocus(event);
    }

    handleKeyDown(e) {
        if (this.props.handleKeyDown != null && e.keyCode === 13) {
            e.preventDefault();
            this.props.handleKeyDown(e);
        }
        else {
            this.inputChange(e);
        }
    }

    render() {
        var returnHTML = [];

        //build the className for the input/textarea element
        var sClassName = "";
        if (this.props.className)
            sClassName = this.props.className;

        var inputClassName = sClassName != "" ? sClassName : "small-input";
        if (this.props.error)
            inputClassName = inputClassName + " inputError";

        var inputID = this.props.id;

        if (this.props.SmallInput) {
            if (this.props.label != null && this.props.label != "") {
                if (!this.props.hasLabel) {
                    returnHTML.push(<label className="simple-specs-label" htmlFor={inputID} id={inputID + "label"} key={this.props.id + "_label"} style={{ display: 'block' }}>{this.props.label || this.props.placeholder} {"\n"}</label>);
                }
            }
            returnHTML.push(
                <input
                    key={this.props.id + "_input"}
                    className={inputClassName}
                    onKeyDown={(e) => { this.handleKeyDown(e); }}
                    disabled={this.props.disabled ? true : false}
                    type={this.props.type || "text"}
                    min={this.props.min || null}
                    id={inputID}
                    onChange={(e) => { this.inputChange(e); }}
                    value={this.props.value || ''}
                    onBlur={(e) => { this.OnBlur(e) }}
                    onFocus={(e) => { this.OnFocus(e) }}
                    placeholder={this.props.placeholder != null ? this.props.placeholder : ''}
                    aria-labelledby={this.props.ariaLabelledBy}
                />
            );
        }
        else {
            var style = {};
            if (this.props.inline)
                style.display = 'inline-block'

            var mileage = "";
            if (this.props.mileage)
                mileage = "mileage-input-div";
            if (this.props.mileageinch)
                mileage = "mileageinch-input-div";
            if (this.props.mileageinchsecond)
                mileage = "mileageinchsecond-input-div";

            //build the className for the input/textarea element
            var sClassName = "";
            if (this.props.className)
                sClassName = this.props.className;

            var inputClassName = "";
            if (this.props.type !== 'textarea')
                inputClassName = this.props.error == true ? sClassName + " inputError" : sClassName;
            else
                inputClassName = this.props.error == true ? "inputError large-text-field" : "large-text-field"

            if (this.props.highlight && this.props.highlight != "")
                inputClassName = inputClassName + " " + this.props.highlight;

            if (this.props.feRequired)
                inputClassName = inputClassName + " fe-required-field";

            //build the id for the input/textarea element
            var inputID = this.props.id;

            var floatRight = {};
            if (this.props.isSpec)
                floatRight.float = "right";

            var label = "";
            if (!this.props.hasLabel) {
                label =
                    this.props.isRequired ?
                        <label id={inputID + "label"} style={floatRight} htmlFor={inputID}><span className="required-red"> *</span>{this.props.label || this.props.placeholder} {"\n"}</label>
                        :
                        <label id={inputID + "label"} style={floatRight} htmlFor={inputID} className="simple-specs-label">{this.props.label || this.props.placeholder} {"\n"}</label>
            }

            let validationError = this.props.type == 'checkbox' ?
                ""
                :
                <p style={{ margin: '0' }} className="validationError">
                    <span dangerouslySetInnerHTML={{ __html: this.props.errorText }}></span>
                </p>;

            returnHTML.push(
                <div key={this.props.id} className={mileage} style={style}>
                    {label}
                    {this.props.type !== 'textarea' ?
                        <input
                            type={this.props.type || "text"}
                            min={this.props.min || null}
                            placeholder={this.props.placeholder}
                            onKeyDown={(e) => { this.handleKeyDown(e); }}
                            disabled={this.props.disabled ? true : false}
                            value={this.props.value || ''}
                            checked={this.props.value == true ? true : ""}
                            onChange={(e) => { this.inputChange(e); }}
                            onBlur={(e) => { this.OnBlur(e) }}
                            onFocus={(e) => { this.OnFocus(e) }}
                            autoComplete={this.props.type === "password" ? "on" : null}
                            className={inputClassName}
                            id={inputID}
                            aria-labelledby={this.props.ariaLabelledBy}
                        />
                        :
                        <textarea
                            placeholder={this.props.placeholder}
                            value={this.props.value || ''}
                            disabled={this.props.disabled ? true : false}
                            onChange={(e) => { this.inputChange(e); }}
                            onBlur={(e) => { this.OnBlur(e) }}
                            onFocus={(e) => { this.OnFocus(e) }}
                            className={inputClassName}
                            id={inputID}
                            aria-labelledby={this.props.ariaLabelledBy}
                        ></textarea>
                    }
                    {validationError}
                </div>
            );
        }

        return (
            returnHTML
        );
    }
}

export default TextField;
global.TextField = TextField;